module.exports = require("./ar-KM.js");